<template>
	<input
		ref="input"
		@keydown="onKeyDown($event)"
		v-model="value"
		class="ag-input-field-input"
	/>
</template>

<script>
export default {
	name: "NumericCellEditor",
	data() {
		return {
			value: "",
			focusAfterAttached: false,
		};
	},
	methods: {
		isCharNumeric(charStr) {
			return charStr != null && !!/^\d+$/.test(charStr);
		},

		isNumericKey(event) {
			const charStr = event.key;
			return (
				this.isCharNumeric(charStr) ||
				event.key === "." ||
				event.key === "Backspace" ||
				event.key === "Delete" ||
				event.key === "ArrowLeft" ||
				event.key === "ArrowRight" ||
				event.key === "Tab"
			);
		},

		onKeyDown(event) {
			if (!this.isNumericKey(event)) {
				event.preventDefault();
			}
		},

		// Focus and select the input field
		focusIn() {
			this.$refs.input.focus();
			this.$refs.input.select();
			console.log("NumericCellEditor.focusIn()");
		},

		// Handle focus out event
		focusOut() {
			console.log("NumericCellEditor.focusOut()");
		},

		// Get the current value
		getValue() {
			const currentValue = this.value;
			return currentValue === "" || currentValue == null
				? null
				: parseFloat(currentValue);
		},
	},
	created() {
		// We only want to highlight this cell if it started the edit
		this.focusAfterAttached = this.params.cellStartedEdit;

		// Initialize with event key if it's numeric, otherwise use provided value
		this.value = this.isCharNumeric(this.params.eventKey)
			? this.params.eventKey
			: this.params.value;
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$refs.input && this.focusAfterAttached) {
				this.$refs.input.focus();
				this.$refs.input.select();
			}
		});
	},
};
</script>

<style scoped>
.ag-input-field-input {
	height: 100%;
	width: 100%;
	padding: 0 5px;
	border: none;
	outline: none;
}
</style>